import { graphql } from "../gql";

export const drgCreateClaimCodeMutationDoc = graphql(`
  mutation drgCreateClaimCode($input: DrgCreateClaimCodeInput!) {
    drgCreateClaimCode(input: $input) {
      id
      code
      codeKind
      codeDescription
      role
      poa
      soi
      rom
      finalCcMccFlag
      claimCodeStatus
      paymentImpact
      paymentImpactAmount
      findingId
      createdBy {
        id
        displayName
      }
      metadata {
        code
        description
        hierarchy
        isBillable
        notes
      }
    }
  }
`);
